import printer from '../utils/printer'
import davinci_printer from '../utils/davinci_printer'
import ksPrinter from '../utils/ksPrinter'
import pddPrinter from '../utils/pddPrinter'
import channelPrinter from "~/utils/channelPrinter";
import xhsPrinter from "~/utils/xhsPrinter";
import PrinterNotifier from "~/utils/printerNotifier"
import utils from '~/utils'
import errorUtils from "~/utils/errorUtils";
import xhsPrinterV2 from "~/utils/xhsPrinterV2";

// 这里保证不同次提交任务的出单有序 (并且如果上次任务是同组件的话，不必等待上次任务结束)
const cloudPrintManager = {
    lastDataFrom: -1,
    lastPrintedPromiseChain: Promise.resolve(),

    getLastDataFrom() {
        return this.lastDataFrom
    },

    setLastDataFrom(dataFrom) {
        this.lastDataFrom = dataFrom
    },

    setLastPrintedPromiseChain(chain) {
        this.lastPrintedPromiseChain = chain
    },

    getLastPrintedPromiseChain() {
        return this.lastPrintedPromiseChain
    },

    updateLastTask(printDataGroup) {
        const {printDataList, dataFrom} = printDataGroup
        const lastPrintData = printDataList[printDataList.length - 1]
        const {waybillId} = lastPrintData
        const chain = new Promise(resolve => {
            PrinterNotifier.addListener(waybillId, 'PRINT_RESULT', resolve)
        })
        cloudPrintManager.setLastDataFrom(dataFrom)
        cloudPrintManager.setLastPrintedPromiseChain(chain)
    },

    resetManager() {
        this.setLastDataFrom(-1)
        this.setLastPrintedPromiseChain(Promise.resolve())
        console.log('打印缓存清除@@', cloudPrintManager)
    }
}

const resetCloudPrinter = () => {
    cloudPrintManager.resetManager()
}

const getConnectStatus = () => {
    let cnPrinter = printer.getConnect()
    let dvcPrinter = davinci_printer.getConnect()
    let ksPrinterConnect = ksPrinter.getConnect()
    let pddConnect = pddPrinter.getConnect()
    let channelConnect = channelPrinter.getConnect()
    const xhsConnect = xhsPrinter.getConnect()
    const XhsV2Connect = xhsPrinterV2.getConnect()
    return cnPrinter || dvcPrinter || ksPrinterConnect || pddConnect || channelConnect || xhsConnect || XhsV2Connect
}

const printValidate = (printDataList, printerName) => {
    if (!getConnectStatus()) {
        throw {message: '请先连接打印组件'}
    }

    if (!printerName) {
        throw {message: '您未选择打印机'}
    }
    printDataList = (printDataList || []).filter(item => item.status === 0)

    if (!printDataList.length) {
        throw {message: '没有可以打印的内容'}
    }
}

const printDataListToGroups = (printDataList) => {
    // 因为跨组件不能保证出单顺序，故不能直接按组件分组，而是按组件连续顺序分组
    const printDataGroups = []
    let lastDataFrom = -1
    printDataList.forEach(printData => {
        const {dataFrom} = printData
        if (lastDataFrom === -1 || dataFrom !== lastDataFrom) {
            const group = {
                dataFrom: dataFrom,
                printDataList: [printData]
            }
            lastDataFrom = dataFrom
            printDataGroups.push(group)
        } else {
            const lastGroup = printDataGroups[printDataGroups.length - 1]
            lastGroup.printDataList.push(printData)
        }
    })
    for (let i = 0; i < printDataGroups.length; i++) {
        const printGroup = printDataGroups[i]
        const nextPrintGroup = printDataGroups[i + 1] || {dataFrom: -1}
        printGroup.nextDataFrom = nextPrintGroup.dataFrom
    }
    return printDataGroups
}

const doPrint = (printData, printerName, reprint) => {
    try {
        printValidate([printData], printerName)
    } catch (err) {
        return Promise.reject(err)
    }
    const groups = printDataListToGroups([printData])
    return basePrint(groups, printerName)
}

const doPrintBath = (printDataList, printerName) => {
    try {
        printValidate(printDataList, printerName)
    } catch (err) {
        return Promise.reject(err)
    }
    const groups = printDataListToGroups(printDataList)
    return basePrint(groups, printerName)
}

function basePrint(printDataGroups, printerName) {
    // 拿到上次的回调promise
    const lastDataFrom = cloudPrintManager.getLastDataFrom()
    const lastPrintedPromise = cloudPrintManager.getLastPrintedPromiseChain()
    // 更新回调链
    const lastGroup = printDataGroups[printDataGroups.length - 1]
    cloudPrintManager.updateLastTask(lastGroup)
    return new Promise((resolve, reject) => {
        const promiseMapper = (printDataGroup) => {
            const {printDataList, dataFrom, nextDataFrom} = printDataGroup
            let taskID = new Date().getTime() + ''
            return doPrintPromise(dataFrom, printDataList, taskID, printerName, nextDataFrom)
        }
        const firstGroup = printDataGroups[0]
        const {dataFrom} = firstGroup
        if (lastDataFrom === -1 || lastDataFrom === dataFrom) {
            // 直接执行
            // console.log('不需要等待上次出单回调@@')
            utils.promiseAllSequentially(printDataGroups, promiseMapper).then(resolve).catch(reject)
        } else {
            lastPrintedPromise.then(() => {
                // 等上一个出单回调完成再执行
                // console.log('上次出单回调完成@@')
                utils.promiseAllSequentially(printDataGroups, promiseMapper).then(resolve).catch(reject)
            })
        }
    })
}

function doPrintPromise(dataFrom, printDataList, taskID, printerName, nextDataFrom) {
    return new Promise((resolve, reject) => {
        let documents = printDataList.map(printData => {
            let document = null
            if (dataFrom === 0) {
                document = printData.printData
            } else if (dataFrom === 7) {
                document = JSON.parse(printData.printData)
            } else if (dataFrom === 1) {
                document = printData.printData
            } else if (dataFrom === 9) {
                document = JSON.parse(printData.printData)
            } else if (dataFrom === 5) {
                document = printData.printData
            } else if (dataFrom === 18) {
                document = printData.printData
            } else {
                reject({message: '组件类型错误'})
                // 及时返回否则会执行后续的代码
                return
            }
            let content = {}
            let contents = null
            let customArea = printData.customArea
            if (dataFrom === 0) {
                content.templateURL = printData.standardTemplateUrl
                content.params = printData.params
                content.signature = printData.signature
                content.encryptedData = document
                const sender = printData.sender
                content.addData = {
                    senderInfo: {
                        contact: {
                            mobile: sender.mobile,
                            name: sender.name
                        }
                    }
                }
                if (printData.sender.address) {
                    const {
                        countryCode,
                        province: provinceName,
                        city: cityName,
                        district: districtName,
                        street: streetName,
                        detail: detailAddress
                    } = printData.sender.address
                    content.addData.senderInfo.address = {
                        countryCode,
                        provinceName,
                        cityName,
                        districtName,
                        streetName,
                        detailAddress
                    }
                }
            } else if (dataFrom === 7) {
                content = document
                if (printData.sender) {
                    content.data.sender = {
                        ...content.data.sender,
                        ...printData.sender,
                    }
                }
            } else if (dataFrom === 1) {
                content.templateURL = printData.standardTemplateUrl
                content.signature = printData.signature
                content.encryptedData = document
                content.key = printData.key
                content.ver = printData.version

                if (customArea && customArea.templateURL) {
                    customArea = {
                        customData: customArea.data,
                        templateURL: customArea.templateURL
                    }
                }

                if (printData.sender) {
                    content.addData = {
                        senderInfo: {
                            contact: {
                                mobile: printData.sender.mobile,
                                name: printData.sender.name
                            }
                        }
                    }
                }

            } else if (dataFrom === 9) {
                //文档表格字段是templateURL, 示例代码是templateUrl
                content.templateUrl = printData.standardTemplateUrl
                content.templateURL = printData.standardTemplateUrl
                content.signature = document.signature
                content.encryptedData = document.encryptedData
                content.ver = document.ver
                content.userid = printData.userId
                //content.wpCode = 'YTO'
            } else if (dataFrom === 5) {
                content = {
                    taskID: printData.waybillId,
                    printInfo: document,
                    printNum: {
                        curNum: 1, // 打印计数-当前张数
                        sumNum: 1, // 打印技术-总张数
                    },
                    // splitControl: 0, // 默认 0 - 根据内容自动分页，
                    // showDeliveryLogo: 1 默认为1， 传0时不展示快递公司logo
                }
                if (customArea && customArea.templateURL) {
                    const {templateURL: templateUrl, data} = customArea
                    content.customInfo = {
                        templateUrl,
                        data
                    }
                }
                if (printData.sender) {
                    const {name: userName, mobile: telNumber} = printData.sender
                    content.extendData = {
                        sender: {
                            userName,
                            telNumber
                        }
                    }
                    if (printData.sender.address) {
                        const {
                            province: provinceName,
                            city: cityName,
                            district: countyName,
                            street: streetName,
                            detail: detailInfo
                        } = printData.sender.address
                        content.extendData.sender.address = {
                            provinceName,
                            cityName,
                            countyName,
                            detailInfo: (streetName ? streetName : '') + detailInfo
                        }
                    }
                }
                return content
            } else if (dataFrom === 18) {
                content.templateURL = printData.standardTemplateUrl
                content.ver = printData.version
                content.signature = printData.signature
                content.encryptedData = printData.printData

                // 自定义区
                if (customArea && customArea.templateURL && customArea.data && customArea.data.item) {
                    customArea = {
                        data: {
                            item: [customArea.data.item]
                        },
                        templateURL: customArea.templateURL
                    }
                }

                if (printData.sender) {
                    content.addData = {
                        sender: {
                            name: printData.sender.name,
                            mobile: printData.sender.mobile
                        }
                    }
                    if (printData.sender.address) {
                        const {province, city, district, street: town, detail} = printData.sender.address
                        content.addData.sender = {
                            province,
                            city,
                            district,
                            town,
                            detail
                        }
                    }
                }
            }

            contents = [content]
            if (customArea && customArea.templateURL) {
                contents.push(customArea)
            }
            return {
                documentID: printData.waybillId,
                contents
            }
        })

        let options = {
            taskID: taskID,
            preview: false,
            printer: printerName,
            previewType: 'pdf',
            documents: documents
        }

        documents.forEach(doc => {
            if (dataFrom === 5) {
                PrinterNotifier.addNotifier(doc.taskID, dataFrom)
            } else {
                PrinterNotifier.addNotifier(doc.documentID, dataFrom)
            }
        })
        const waitUtilGroupPrintedPromise = delayPromise(printDataList, nextDataFrom)
        // console.log('提交任务@@', dataFrom)
        if (dataFrom === 0) {
            davinci_printer.print({task: options}).then(() => {
                // resolve()
                waitUtilGroupPrintedPromise.then(() => {
                    // console.log('出单任务回调@@', dataFrom)
                    resolve()
                })
            }).catch(err => {
                printCatchHandler(documents, err)
                reject(err)
            })
        } else if (dataFrom === 7) {
            printer.print({task: options}).then(() => {
                waitUtilGroupPrintedPromise.then(() => {
                    // console.log('出单任务回调@@', dataFrom)
                    resolve()
                })
            }).catch(err => {
                printCatchHandler(documents, err)
                reject(err)
            })
        } else if (dataFrom === 1) {
            //快手
            const {documents} = options
            options.firstDocumentNumber = 1
            options.totalDocumentCount = printDataList.length
            documents.forEach(dc => {
                //必传
                dc.ksOrderFlag = true
            })
            ksPrinter.print({task: options}).then(() => {
                waitUtilGroupPrintedPromise.then(() => {
                    // console.log('出单任务回调@@', dataFrom)
                    resolve()
                })
            }).catch(err => {
                printCatchHandler(documents, err)
                reject(err)
            })
        } else if (dataFrom === 9) {
            options.previewType = 'image'
            // 订阅出单结果通知：拼多多组件需显式声明 notifyType 才会回调 PrintResultNotify(用于维护出单数量)
            options.notifyType = ['print']
            pddPrinter.print({task: options}).then(() => {
                waitUtilGroupPrintedPromise.then(() => {
                    // console.log('出单任务回调@@', dataFrom)
                    resolve()
                })
            }).catch(err => {
                printCatchHandler(documents, err)
                reject(err)
            })
        } else if (dataFrom === 5) {
            const cOptions = {
                taskList: documents,
                printType: 1, // Number 打印类型，默认为 1，打印固定高度的面单
                printer: printerName
            }
            channelPrinter.print(cOptions).then(() => {
                waitUtilGroupPrintedPromise.then(() => {
                    // console.log('出单任务回调@@', dataFrom)
                    resolve()
                })
            }).catch(err => {
                printCatchHandler(documents, err)
                reject(err)
            })
        } else if (dataFrom === 18) {
            let newBillVersion = printDataList[0].newBillVersion || false
            if (newBillVersion) {
                xhsPrinterV2.print({task: options}).then(() => {
                    waitUtilGroupPrintedPromise.then(() => {
                        resolve()
                    })
                }).catch(err => {
                    printCatchHandler(documents, err)
                    reject(err)
                })
            } else {
                xhsPrinter.print({task: options}).then(() => {
                    waitUtilGroupPrintedPromise.then(() => {
                        resolve()
                    })
                }).catch(err => {
                    printCatchHandler(documents, err)
                    reject(err)
                })
            }
        }
    })
}

function printCatchHandler(documents, err) {
    documents.forEach(doc => {
        const response = {
            documentID: doc.documentID,
            status: 'failed',
            msg: JSON.stringify(err),
            successCount: 0,
            failCount: 1
        }
        PrinterNotifier.setNotifierResponse(doc.documentID, response)
        PrinterNotifier.notifyListeners(doc.documentID)
        try {
            errorUtils.uploadError('printCatchHandler', JSON.stringify(response))
        } catch (e) {
        }
    })
}

function delayPromise(printDataList, nextDataFrom) {
    // 保证单次提交的printData即使跨组件也是出单有序的
    if (nextDataFrom === -1) {
        // 后面没有任务
        return Promise.resolve()
    } else {
        const lastPrintData = printDataList[printDataList.length - 1]
        const {waybillId} = lastPrintData
        return new Promise(resolve => {
            PrinterNotifier.addListener(waybillId, 'PRINT_RESULT', resolve)
        })
    }
}

export default {
    getConnectStatus,
    doPrint,
    doPrintBath,
    resetCloudPrinter
}



// WEBPACK FOOTER //
// ./src/service/cloudprint.js